import React from "react";
import { useSoundContext } from "../../../SoundContext";
import "../../../styles/utils/button/MusicToggleButton.scss";

export default function MusicToggleButton() {
  const { isMuted, toggleMute } = useSoundContext();

  return (
    <button className="music-toggle-btn" onClick={toggleMute}>
      <img
        src={
          isMuted
            ? "/images/utils/button/music-off.svg"
            : "/images/utils/button/music-on.svg"
        }
        alt={isMuted ? "음악 끔" : "음악 켬"}
      />
    </button>
  );
}
